import {CompaniesProvider} from './CompaniesContext';
import {UsersProvider} from './UsersContext';

export const AdminProvider = ({children}) => (
  <CompaniesProvider>
    <UsersProvider>{children}</UsersProvider>
  </CompaniesProvider>
);
